module.exports = __webpack_public_path__ + "img/badge.35bb0623.png";